
import MainMenu from "./modules/MainMenu";
import ScrollTo from "./modules/ScrollTo";
import Tabs from "./modules/Tabs";
import BlockLink from "./modules/BlockLink";

document.addEventListener( 'DOMContentLoaded', () => {
    // parse translations as json
    // ctheme.translations = JSON.parse(ctheme.translations);

    new MainMenu();
    new ScrollTo();
    new BlockLink();
    // new Tabs();

    // external links
    const links = document.querySelectorAll('a');
    links.forEach(el => {
        var a = new RegExp('/' + window.location.host + '/');
        if(!a.test(el.href)) {
            el.setAttribute('target', '_blank');
            el.classList.add('external-link');

            el.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                window.open(e.target.href, '_blank');
            }, this);
        }
    });
});